/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Link } from 'foundations-components/transitional/components/Link';
import { Select } from 'foundations-components/transitional/components/Select';
import { userInfoSync } from 'hub-http/userInfo';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { LinkTypes } from '../../constants/link';
import { formatUserName, getAlphabeticalSortPrioritizingUser, getSetupMeetingLinkUrl } from '../../utils/link';
import { jsx as _jsx } from "react/jsx-runtime";
const getMeetingDisplay = (meeting, formattedUserName) => meeting.name || I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.MEETING}.defaultName`, {
  user: formattedUserName
});
export default class MeetingLinkField extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleChange = ({
      target: {
        value
      }
    }) => {
      this.props.onChange({
        url: value.value,
        meetingName: value.text
      });
    };
    this.fetchMeetingLinks = (_input, callback) => {
      this.props.fetchMeetingsByUsers().then(meetingsByUser => {
        const options = meetingsByUser.map(user => ({
          text: formatUserName(user),
          userId: user.id,
          options: user.meetings.map(meeting => ({
            help: meeting.link,
            value: meeting.link,
            userId: meeting.userId,
            text: getMeetingDisplay(meeting, formatUserName(user)),
            id: meeting.id
          }))
        }));
        if (!options.length) {
          options.push({
            text: I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.MEETING}.noMeetingsTitle`),
            disabled: true,
            help: /*#__PURE__*/_jsx(Link, {
              href: getSetupMeetingLinkUrl(),
              external: true,
              children: I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.MEETING}.noMeetingsHelp`)
            })
          });
        } else {
          options.sort(getAlphabeticalSortPrioritizingUser(this.userId));
        }
        callback(null, {
          options
        });
      });
    };
  }
  componentDidMount() {
    if (this.props.userId) {
      this.userId = this.props.userId;
    } else {
      try {
        const {
          user
        } = userInfoSync();
        this.userId = user.user_id;
      } catch (error) {
        // DO NOTHING - all this means is that we cannot prioritize
        // the current user in the sorted meeting link list
      }
    }
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const {
      url
    } = this.props;
    return /*#__PURE__*/_jsx(FormControl, {
      label: I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.MEETING}.label`),
      marginBlockStart: "0",
      children: /*#__PURE__*/_jsx(Select, {
        autoload: true,
        loadOptions: this.fetchMeetingLinks,
        filterOptions: true,
        searchable: true,
        value: url,
        onSelectedOptionChange: this.handleChange,
        placeholder: I18n.text(`RichTextLib.links.linkTypes.${LinkTypes.MEETING}.placeholder`)
      })
    });
  }
}
MeetingLinkField.propTypes = {
  userId: PropTypes.number,
  fetchMeetingsByUsers: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  url: PropTypes.string
};